// extracted by mini-css-extract-plugin
export default {"page":"LeadExportDetails_page__8WjyH"};